import { useRef, type ReactNode } from 'react'
import { useReededGlass } from '@/components/motion/useReededGlass'
import { cx } from '@/lib/cx'

type GlassPanelProps = {
  className: string
  /** The white wash over the glass: the hero's keeps the left side readable, the invitation's is stronger. */
  shade: 'hero' | 'invite'
  id?: string
  labelledBy: string
  /** False keeps the glass still until the pointer stirs it, for pages without a pause control. */
  ambient?: boolean
  children: ReactNode
}

/** A panel of live reeded glass: the hero of a page and the invitation that closes it. */
export const GlassPanel = ({ className, shade, id, labelledBy, ambient = true, children }: GlassPanelProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const supported = useReededGlass(canvasRef, { ambient })

  return (
    <section id={id} className={cx('panel', className, !supported && 'no-gl')} aria-labelledby={labelledBy}>
      <canvas ref={canvasRef} className="reeded" aria-hidden="true" />
      <div className="hero-grain" aria-hidden="true" />
      <div className={shade === 'hero' ? 'hero-shade' : 'x-invite-shade'} aria-hidden="true" />
      {children}
    </section>
  )
}
